import { CoverPage, DisclaimerPage } from './Layouts/StaticPages';

export const STATIC_END_PAGES = [DisclaimerPage, CoverPage];
